app.component('packageView', {
    bindings: {},
    templateUrl: './App/Packages/PackageView.html',
    controller: ['$scope', 'growl', 'sessions', 'packageService', '$location', '$interval',
        function ($scope, growl, sessions, packageService, $location, $interval) {

        var that = this;
        that.packages = that.packages ?? [];
        that.vendorSignupLink = 'https://www.recolorado.com/pros/media-provider-sign-up';
        that.createPackageAction = 'Create Media Package';
        that.zipLinkUrl = null;
        that.zipLinkUrlIsValid = false;
        that.isValidatingZipUrl = false;

        that.copySignupLink = function () {
            navigator.clipboard.writeText(that.vendorSignupLink);
            growl.success('Sign-up link copied to clipboard');
        };

        that.init = function () {
            that.resort(null, null, true);
            sessions.initDropdowns();
            that.packages = that.getMyPackages();
            that.session = sessions.getCurrent();
            sessions.verifyCurrentSession(); //make sure that current session is still valid
            that.isVendor = that.session.isVendor;
            that.createPackageAction = that.isVendor ? that.createPackageAction : 'Import Photos from Link';
            //setup auto refresh when one or more packages are in transition states
            that.refreshStatuses = ['Publishing', 'Publishing...', 'ImportingDropbox', 'Importing photos...'];
            that.zipLinkUrl = null;

            $interval(that.updateStatuses, 5000); // 5000ms = 5 seconds
        }

        that.needsAction = function (package) {
            return package &&
                (package.MediaStatus == 'Draft'
                || (that.session.isAgent && package.MediaStatus == 'Ready'));
        };

        that.isShared = function (package) {
            return package && package.MediaStatus != 'Draft';
        };

        that.packageStatus = function (package, showLongStatus) {
            let status = showLongStatus ? package.MediaStatusLong : package.MediaStatus;
            if (package.MediaStatus == 'Ready' && that.session.isVendor)
                status = showLongStatus ? 'Shared with Agent' : 'Shared';
            if (package.IsRetryingPublishAfterError)
                status = showLongStatus ? "Retrying Publish..." : "Retrying";
            return status;
        }

        that.ExpirationInDays = function (expirationDate) {
            var time = (new Date(expirationDate)).getTime() - Date.now();
            var days = time / (1000 * 3600 * 24);
            return Math.round(days);
        };

        that.showExpiration = function (package) {
            return false; // (package.MediaStatus == 'Draft' || package.MediaStatus == 'Ready') && package.ExpirationTimestamp != null;
        }

        that.resort = function (field, label, setDefaults) {
            if (setDefaults) {
                that.sortLabel = 'Date';
                that.sortAsc = false;
                that.sortValue = '-ModificationTimestamp';
            }
            else {
                that.sortLabel = label;
                if (field === that.sortValue) {
                    that.sortAsc = false;
                    that.sortValue = '-' + field;
                } else {
                    that.sortAsc = true;
                    that.sortValue = field;
                }
            }
        };

        that.toggleSortDir = function () {
            that.sortAsc = that.sortValue.startsWith('-');
            that.sortValue = that.sortAsc ? that.sortValue.substr(1) : '-' + that.sortValue;
        };

        that.getMyPackages = function () {
            if (that.loadingPackages) return;

            that.loadingPackages = true;
            packageService.getPackages({
                onSuccess: packages => {
                    that.packages = packages;
                    that.resort(that.sortValue, that.sortLabel, true);
                },
                onComplete: _ => {
                    that.loadingPackages = false
                }
            });
        };

        that.selectPackage = function (package) {
            if (package.IsUnavailable) {
                package.isHighlighted = true;
                setTimeout(() => {
                    $scope.$apply(() => { package.isHighlighted = false; });
                }, 3000);
            } else {
                $location.url(`/packages/${package.MediaPackageId}`);
            }
        }

        that.searchListings = function () {
            $location.url('/listings');
        }

        //send feedback
        that.sendFeedback = function () {
            that.notifyIsFeedback = true;
            that.notifyTitle = 'Send Feedback';
            that.notifyMessage = `Tell us what you think.`;;
            that.openNotifyModal = true;
        }

        //Listing Link Button
        that.linkPackage = function (packageId) {
            $location.url(`/packages/${packageId}/linklisting`)
        }

        that.updateStatuses = function () {
            if (!Array.isArray(that.packages))
                return;
            
            var count = that.packages.filter(pkg => that.refreshStatuses.includes(pkg.MediaStatus) || pkg.IsRetryingPublishAfterError).length;
            if (count > 0) {
                console.log('refreshing package view');
                that.getMyPackages()
            }
        };

        that.handleValidZipUrl = function () {
            that.isValidatingZipUrl = true;
            packageService.isValidZipUrl(that.zipLinkUrl)
                .then(r => {
                    that.isValidZipUrl = r.isValid;
                    that.isValidatingZipUrl = false;
                });
        };

        that.handleCreateFromZipUrl = function () {
            if (that.isValidZipUrl && !that.isValidatingZipUrl)
                that.showCreatePackage = true;
            };

        that.handleCreateFromScratch = function () {
            if (!that.isValidatingZipUrl)
                that.showCreatePackage = true;
        };

        that.init();
    }]
});